export default __webpack_public_path__ + "static/media/34-Chiller.bc3911dd.jpeg";